



























































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import { PageItem, FieldItem, SheetField, Pos } from "../../modules/teacher/PositionEdit"
// @ts-ignore
import VueDragResize from "vue-drag-resize";

const StepEnum = Object.freeze({Step1: 1, Step2: 2});
const DirectionEnum = Object.freeze({Horizontal: 1, Vertical: 2});

export interface Data {
  currentPage: number
  sheet_id: string
  sheet: any
  pageItems: PageItem[]
  scale: number
  step: number
  isMouseDown: boolean
  beginPos: Pos
  baseFieldItem: FieldItem
  currentFieldItem: FieldItem | null
  currentSheetField: SheetField | null
  borderWidth: number
  errors: string[]
  StepEnum: Readonly<{Step1: number;Step2: number;}>
  DirectionEnum: Readonly<{Horizontal: number;Vertical: number;}>
  SheetFieldKindEnum: Readonly<{FIELD: number; TOTAL_SCORE: number; PART1: number; VIEW_POINT: number; STUDENT_INFO: number}>
  isShiftPressed: boolean
  multiSelectedFieldItems: FieldItem[]
  isManumalAssignSheetFields: boolean
  isDeleteMode: boolean
  sheetFieldNamePos: Pos
  key: number
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "vue-drag-resize": VueDragResize,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      currentPage: 1,
      sheet_id: "",
      sheet: {corretct_image_completed: true},
      pageItems: [],
      scale: 0.5,
      step: StepEnum.Step1,
      isMouseDown: false,
      beginPos: new Pos(0, 0),
      baseFieldItem: new FieldItem(),
      currentFieldItem: null,
      currentSheetField: null,
      borderWidth: 2,
      errors: [],
      StepEnum: StepEnum,
      DirectionEnum: DirectionEnum,
      SheetFieldKindEnum: Common.SheetFieldKindEnum,
      isShiftPressed: false,
      multiSelectedFieldItems: new Array<FieldItem>(),
      isManumalAssignSheetFields: false,
      isDeleteMode: false,
      sheetFieldNamePos: new Pos(0, 0),
      key: 1,
    });

    /****************************************
     * 現在表示中のページ情報
     ****************************************/

    const currentPageItem = computed(() => {
      return state.pageItems.length > 0 ? state.pageItems[state.currentPage - 1] : null;
    });

    /****************************************
     * 倍率を加味した画像の横幅
     ****************************************/

    const parentW = computed(() => {
      return currentPageItem.value.baseWidth * state.scale;
    });

    /****************************************
     * 倍率を加味した画像の横幅
     ****************************************/

    const parentH = computed(() => {
      return currentPageItem.value.baseHeight * state.scale;
    });

    /****************************************
     * 画像のサイズCSSスタイル
     ****************************************/

    const sizeStyle = computed(() => {
      let style: any = {};
      style["width"] = `${parentW.value}px`;
      style["height"] = `${parentH.value}px`;
      return style;
    });

    /****************************************
     * 点線枠のCSSスタイル
     ****************************************/

    const baseFieldStyle = computed(() => {
      let style: any = {};
      style["left"] = `${state.baseFieldItem.x * state.scale}px`;
      style["top"] = `${state.baseFieldItem.y * state.scale}px`;
      style["width"] = `${state.baseFieldItem.width * state.scale}px`;
      style["height"] = `${state.baseFieldItem.height * state.scale}px`;
      style["display"] = state.baseFieldItem.width > 0 && state.baseFieldItem.height > 0 ? "block" : "none";
      return style;
    });

    /****************************************
     * 手動設問割当て時にカーソルに追従する設問名のCSSスタイル
     ****************************************/

    const sheetFieldNamePosStyle = computed(() => {
      let style: any = {};
      style["left"] = `${state.sheetFieldNamePos.x + 20}px`;
      style["top"] = `${state.sheetFieldNamePos.y}px`;
      return style;
    });

    const isSelected = (fieldItem: FieldItem) => {
      return state.currentFieldItem == fieldItem || state.multiSelectedFieldItems.indexOf(fieldItem) != -1;
    };

    /****************************************
     * ショートカットキー用のダミーチェックボックスにフォーカス
     ****************************************/

    const focus = () => {
      // @ts-ignore
      const elem = document.getElementById("dummy-checkbox");
      if(elem != null){
        elem.focus();
      }
    };

    /****************************************
     * 画面サイズに合わせてレイアウト整形
     ****************************************/

    const adjustHeight = () => {
      const winH = window.innerHeight;
      const tableArea = document.getElementById("table-area");
      const imageArea = document.getElementById("image-area");

      if(tableArea != null && imageArea != null){
        tableArea.style.height = (winH - tableArea.offsetTop) + "px";
        imageArea.style.height = (winH - imageArea.offsetTop) + "px";
      }
    };

    /****************************************
     * 画像を表示エリアの横幅に合わせる
     ****************************************/

    const adjustWidth = () => {
      const elem = document.getElementById("image-area");
      if(elem != null){
        const imageAreaW = elem.clientWidth - 30;
        state.scale = imageAreaW / currentPageItem.value.baseWidth;
      }
    };

    /****************************************
     * 拡大ボタン押下
     ****************************************/

    const scaleUp = () => {
      state.scale += 0.05;
    };

    /****************************************
     * 縮小ボタン押下
     ****************************************/

    const scaleDown = () => {
      if(state.scale > 0.2){
        state.scale -= 0.05;
      }
    };

    /****************************************
     * ゴミ箱ボタン押下 削除モード切り替え
     ****************************************/
    
    const toggleDeleteMode = () => {
      state.isDeleteMode = !state.isDeleteMode;
    };

    /****************************************
     * マウスダウン 枠設定処理開始
     ****************************************/
    
    const mouseDown = (e: any) => {
      if(state.step == StepEnum.Step1 && !state.isDeleteMode){
        state.isMouseDown = true;
        state.beginPos = new Pos(e.offsetX / state.scale, e.offsetY / state.scale);
      }

      clearCurrentItem();
    };

    /****************************************
     * マウス移動中 枠のサイズ更新
     ****************************************/
    
    const mouseMove = (e: any) => {
      if(state.step == StepEnum.Step1 && state.isMouseDown){
        let x = 0, y = 0;
        if(e.target.id == "image-wrap"){
          x = e.offsetX / state.scale;
          y = e.offsetY / state.scale;
        }else{
          x = (e.offsetX + e.target.offsetLeft + state.borderWidth * 2) / state.scale;
          y = (e.offsetY + e.target.offsetTop + state.borderWidth * 2) / state.scale;
        }
        
        if(x > state.beginPos.x){
          state.baseFieldItem.x = state.beginPos.x;
          state.baseFieldItem.width = x - state.beginPos.x;
        }else{
          state.baseFieldItem.x = x;
          state.baseFieldItem.width = state.beginPos.x - x;
        }

        if(y > state.beginPos.y){
          state.baseFieldItem.y = state.beginPos.y;
          state.baseFieldItem.height = y - state.beginPos.y;
        }else{
          state.baseFieldItem.y = y;
          state.baseFieldItem.height = state.beginPos.y - y;
        }
      }else if(state.step == state.StepEnum.Step2 && state.isManumalAssignSheetFields){
        let x = 0, y = 0;
        if(e.target.id == "image-wrap"){
          x = e.offsetX;
          y = e.offsetY;
        }else{
          x = e.offsetX + e.target.offsetLeft;
          y = e.offsetY + e.target.offsetTop;
        }
        state.sheetFieldNamePos = new Pos(x, y);
      }
    };

    /****************************************
     * マウスボタンアップ
     ****************************************/
    
    const mouseUp = () => {
      if(state.step == StepEnum.Step1 && state.isMouseDown){
        state.isMouseDown = false;
        addFieldItem();
      }
    };

    /****************************************
     * マウス範囲外イベント
     ****************************************/
    
    const mouseLeave = () => {
      if(state.step == StepEnum.Step1 && state.isMouseDown){
        state.isMouseDown = false;
        addFieldItem();
      }
    };

    /****************************************
     * 枠情報追加
     ****************************************/
    
    const addFieldItem = () => {
      if(state.baseFieldItem.width > 50 && state.baseFieldItem.height > 50){
        // 点線枠から位置・サイズ情報を抽出しページ配下の枠追加
        const fieldItem = new FieldItem();
        fieldItem.key = state.key++;
        fieldItem.x = state.baseFieldItem.x;
        fieldItem.y = state.baseFieldItem.y;
        fieldItem.width = state.baseFieldItem.width;
        fieldItem.height = state.baseFieldItem.height;
        currentPageItem.value.fieldItems.push(fieldItem);
        changeCurrentFieldItem(fieldItem);
      }
      
      // 点線枠リセット
      state.baseFieldItem.x = 0;
      state.baseFieldItem.y = 0;
      state.baseFieldItem.width = 0;
      state.baseFieldItem.height = 0;
    };

    /****************************************
     * 枠のドラッグ終了時イベント
     ****************************************/
    
    const dragStop = (fieldItem: FieldItem, rect: any) => {

      if(rect.left < 0){
        fieldItem.x = 0;
      }else if(rect.left + rect.width > parentW.value){
        fieldItem.x = (parentW.value - rect.width) / state.scale;
      }else{
        fieldItem.x = rect.left / state.scale;
      }

      if(rect.top < 0){
        fieldItem.y = 0;
      }else if(rect.top + rect.height > parentH.value){
        fieldItem.y = (parentH.value - rect.height) / state.scale;
      }else{
        fieldItem.y = rect.top / state.scale;
      }
    };

    /****************************************
     * 枠のリサイズ終了時イベント
     ****************************************/
    
    const resizeStop = (fieldItem: FieldItem, rect: any) => {
      if(rect.left < 0){
        fieldItem.width = fieldItem.width + fieldItem.x;
        fieldItem.x = 0;
      }else if(rect.left + rect.width > parentW.value){
        fieldItem.width = (parentW.value - rect.left) / state.scale;
      }else{
        fieldItem.width = rect.width / state.scale;
      }

      if(rect.top < 0){
        fieldItem.height = fieldItem.height + fieldItem.y;
        fieldItem.y = 0;
      }else if(rect.top + rect.height > parentH.value){
        fieldItem.height = (parentH.value - rect.top) / state.scale;
      }else{
        fieldItem.height = rect.height / state.scale;
      }
    };

    /****************************************
     * 枠をクリック
     ****************************************/

    const fieldClick = (fieldItem: FieldItem) => {
      const currentFieldItemCache = state.currentFieldItem;
      changeCurrentFieldItem(fieldItem);

      if(state.step == state.StepEnum.Step1){

        if(state.isDeleteMode){
          deleteFieldItem(fieldItem);
        }else{
          if(state.isShiftPressed){
            // 複数選択モード
            if(state.multiSelectedFieldItems.indexOf(currentFieldItemCache) == -1){
              state.multiSelectedFieldItems.push(currentFieldItemCache);
            }
            if(state.multiSelectedFieldItems.indexOf(fieldItem) == -1){
              state.multiSelectedFieldItems.push(state.currentFieldItem);
            }
          }else{
            // 単一選択モード 複数選択済み枠情報をクリア
            state.multiSelectedFieldItems = new Array<FieldItem>();
          }
        }
        
      }else if(state.isManumalAssignSheetFields){
        
        // 枠に設問を割り当てる
        fieldItem.sheetField = state.currentSheetField;
        const nextIdx = currentPageItem.value.sheetFields.indexOf(state.currentSheetField) + 1;
        
        if(nextIdx + 1 > currentPageItem.value.sheetFields.length){
          // 最後の設問だった場合、手動モードをOFF
          state.isManumalAssignSheetFields = false;
        }else{
          // 次の設問へ切り替え
          state.currentSheetField = currentPageItem.value.sheetFields[nextIdx];
        }
      }else{
        state.currentSheetField = fieldItem.sheetField;
      }
    };

    /****************************************
     * 一覧の行クリック
     ****************************************/
    
    const trClick = (sheetField: SheetField) => {
      if(state.step != state.StepEnum.Step2 || !state.isManumalAssignSheetFields){
        const fieldItems = currentPageItem.value.fieldItems.filter((x: FieldItem) => x.sheetField == sheetField);
        if(fieldItems.length > 0){
          changeCurrentFieldItem(fieldItems[0]);
          state.currentSheetField = sheetField;
        }
      }
    };
    
    /****************************************
     * 枠情報削除
     ****************************************/
    
    const deleteFieldItem = (fieldItem: FieldItem) => {
      const fieldItems = currentPageItem.value.fieldItems.filter((x: FieldItem) => x != fieldItem);
      currentPageItem.value.fieldItems = fieldItems;
      state.currentFieldItem = null;
      state.currentSheetField = null;
    };

    /****************************************
     * 選択中の枠変更
     ****************************************/
    
    const changeCurrentFieldItem = (fieldItem: FieldItem) => {
      const isActive: boolean = fieldItem.isActive;
      for(let item of currentPageItem.value.fieldItems){
        item.isActive = false;
      }
      fieldItem.isActive = !isActive;
      if(fieldItem.isActive){
        state.currentFieldItem = fieldItem;
      }else{
        clearCurrentItem();
      }

      if(fieldItem.sheetField != null){
        state.currentSheetField = fieldItem.sheetField;
      }
    };

    /****************************************
     * 枠選択情報クリア
     ****************************************/
    
    const clearCurrentItem = () => {
      state.currentFieldItem = null;
      state.currentSheetField = null;
      currentPageItem.value.fieldItems.forEach((x: FieldItem) => {
        x.isActive = false;
      });
    };
    
    /****************************************
     * 枠自動設定 API呼び出し
     ****************************************/
    
    const autoCreateFieldItems = async () => {

      context.root.$store.dispatch("showOverlay");

      await http.get(`/api/position_edit/image_rect_auto_generate/${state.sheet_id}?page=${state.currentPage}&direction=horizontal`).then(response => {
        let fieldItems = new Array<FieldItem>();
        for(const rimArray of response.data.result){
          let item = new FieldItem();
          item.key = state.key++;
          item.x = rimArray[0];
          item.y = rimArray[1];
          item.width = rimArray[2];
          item.height = rimArray[3];
          fieldItems.push(item);
        }
        currentPageItem.value.fieldItems = fieldItems;
        state.currentFieldItem = null;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /****************************************
     * 枠情報リセット
     ****************************************/
    
    const resetFieldItems = () => {
      currentPageItem.value.fieldItems = new Array<FieldItem>();
      state.currentFieldItem = null;
    };

    /****************************************
     * 枠設定確定
     ****************************************/
    
    const fixFieldItems = () => {
      if(currentPageItem.value.fieldItems.length != currentPageItem.value.sheetFields.length){
        alert("項目数（合計点 + 設問数）と一致しません");
        return;
      }
      state.step = state.StepEnum.Step2;
    };

    /****************************************
     * 設問割当て自動設定
     ****************************************/
    
    const autoAssignSheetFields = (direction: number) => {
      state.currentSheetField = currentPageItem.value.sheetFields[0];
      setSortNo(currentPageItem.value.fieldItems, 1, direction);
      currentPageItem.value.fieldItems.sort((a: FieldItem, b: FieldItem) => a.sortNo - b.sortNo).forEach((fieldItem: FieldItem) => {
        fieldItem.sheetField = state.currentSheetField;
        const nextIdx = currentPageItem.value.sheetFields.indexOf(state.currentSheetField) + 1;
        state.currentSheetField = currentPageItem.value.sheetFields[nextIdx];
      });
    };

    /****************************************
     * 設問自動割当て用の順序番号設定
     ****************************************/
    
    const setSortNo = (fieldItems: FieldItem[], num: number, direction: number) => {
      if(direction == state.DirectionEnum.Horizontal){
        const topField = fieldItems.sort((a, b) => a.y - b.y)[0];

        let someFields = fieldItems.filter(f => f.y - topField.y < 50);
        let otherFields = fieldItems.filter(f => !(f.y - topField.y < 50));

        someFields.sort((a, b) => a.x - b.x).forEach(f => {
          f.sortNo = num;
          num += 1;
        });

        if (otherFields.length > 0) {
          setSortNo(otherFields, num, direction);
        }
      }else{
        const rightField = fieldItems.sort((a, b) => (b.x + b.width) - (a.x + a.width))[0];

        let someFields = fieldItems.filter(f => (rightField.x + rightField.width) - (f.x + f.width) < 50);
        let otherFields = fieldItems.filter(f => !((rightField.x + rightField.width) - (f.x + f.width) < 50));

        someFields.sort((a, b) => a.y - b.y).forEach(f => {
          f.sortNo = num;
          num += 1;
        });

        if (otherFields.length > 0) {
          setSortNo(otherFields, num, direction);
        }
      }
    };

    /****************************************
     * 設問手動割当て
     ****************************************/
    
    const manualAssignSheetFields = () => {
      state.isManumalAssignSheetFields = !state.isManumalAssignSheetFields;
      if(state.isManumalAssignSheetFields){
        state.currentSheetField = currentPageItem.value.sheetFields[0];
        for(const fieldItem of currentPageItem.value.fieldItems){
          fieldItem.isActive = false;
        }
      }
    };

    /****************************************
     * 設問割当てリセット
     ****************************************/
    
    const resetSheetFields = () => {
      state.currentSheetField = null;
      for(const fieldItem of currentPageItem.value.fieldItems){
        fieldItem.sheetField = null;
      }
    };

    /****************************************
     * 保存ボタン押下
     ****************************************/
    
    const saveSheetFields = async () => {

      // エラーチェック
      state.errors = [];
      for(const pageItem of state.pageItems){
        
        if(pageItem.fieldItems.length != pageItem.sheetFields.length){
          state.errors.push(`${pageItem.pageNo}ページ目の項目数（合計点 + 設問数）と枠の数が一致しません。`);
          continue;
        }
        
        let registeredSheetFields = pageItem.fieldItems.filter((x: FieldItem) => x.sheetField != null).map((x: FieldItem) => x.sheetField);
        for(const sheetField of pageItem.sheetFields){
          if(registeredSheetFields.indexOf(sheetField) == -1){
            state.errors.push(`${pageItem.pageNo}ページ目の「${sheetField.name}」の枠設定が完了していません。`);
          }
        }
      }

      // エラーありの場合は処理終了
      if(state.errors.length > 0 || !window.confirm("採点枠を保存します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      let sheetFields = new Array<SheetField>();
      for(const pageItem of state.pageItems){
        for(const fieldItem of pageItem.fieldItems){
          const rim = [fieldItem.x, fieldItem.y, fieldItem.width, fieldItem.height];
          // @ts-ignore
          fieldItem.sheetField.rim = rim;
          // @ts-ignore
          sheetFields.push(fieldItem.sheetField);
        }
      }

      await http.patch(`/api/position_edit/${state.sheet_id}`, {sheet_fields: sheetFields}).then(response => {
        alert("処理が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /****************************************
     * ページ切り替え
     ****************************************/
    
    const changePage = (page: number) => {
      clearCurrentItem();
      state.step = state.StepEnum.Step1;
    };

    /****************************************
     * backspaceキー押下 選択中の枠を削除
     ****************************************/
    
    const pressedBackspace = () => {
      if(state.step == state.StepEnum.Step1 && state.currentFieldItem != null){
        deleteFieldItem(state.currentFieldItem);
      }
    };

    /****************************************
     * Cキー押下 選択中の枠を複製
     ****************************************/
    
    const copyFieldItem = (baseFieldItem: FieldItem) => {
      let fieldItem = new FieldItem();
      fieldItem.width = baseFieldItem.width;
      fieldItem.height = baseFieldItem.height;
      
      fieldItem.x = baseFieldItem.x;
      fieldItem.y = baseFieldItem.y + baseFieldItem.height;
      
      currentPageItem.value.fieldItems.push(fieldItem);
      changeCurrentFieldItem(fieldItem);
    };

    /****************************************
     * Cキー押下 枠複製
     ****************************************/
    
    const pressedC = () => {
      if(state.step != state.StepEnum.Step1){
        return;
      }

      if(state.multiSelectedFieldItems.length > 0){
        // 複数選択中の枠をコピー
        for(const fieldItem of state.multiSelectedFieldItems){
          copyFieldItem(fieldItem);
        }
      }else if(state.currentFieldItem != null){
        // 選択中の枠単体をコピー
        copyFieldItem(state.currentFieldItem);
      }
    };

    /****************************************
     * Shiftキー押下
     ****************************************/
    
    const pressedShift = () => {
      state.isShiftPressed = true;
    };

    /****************************************
     * Shiftキー押下終了
     ****************************************/
    
    const unpressedShift = () => {
      state.isShiftPressed = false;
    };

    const pressedArrowUp = () => {
      if(state.currentFieldItem != null){
        const idx = currentPageItem.value.fieldItems.indexOf(state.currentFieldItem);
        if(idx > 0){
          state.multiSelectedFieldItems = new Array<FieldItem>();
          changeCurrentFieldItem(currentPageItem.value.fieldItems[idx - 1]);
        }
      }
    };

    const pressedArrowDown = () => {
      if(state.currentFieldItem == null){
        state.multiSelectedFieldItems = new Array<FieldItem>();
        changeCurrentFieldItem(currentPageItem.value.fieldItems[0]);
      }else{
        const idx = currentPageItem.value.fieldItems.indexOf(state.currentFieldItem);
        if(idx + 1 < currentPageItem.value.fieldItems.length){
          state.multiSelectedFieldItems = new Array<FieldItem>();
          changeCurrentFieldItem(currentPageItem.value.fieldItems[idx + 1]);
        }
      }
    };

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;

      // APIで登録済み試験情報取得
      await http.get(`/api/position_edit?sheet_id=${state.sheet_id}`).then(response => {
        
        state.sheet = response.data.sheet;

        if(response.data.sheet.corretct_image_completed){
          adjustHeight();
          window.addEventListener("resize", adjustHeight);

          // ページごとに取得データを仕分ける
          for(let i = 0; i < state.sheet.page_count; i++){
            
            const pageItem = new PageItem(i + 1, response.data.base64_images[i], response.data.image_size_hashes[i].width, response.data.image_size_hashes[i].height);
            for(var sheet_field of response.data.sheet_fields.filter((x: any) => x.page == i + 1)){
              
              // 答案並び替え機能が無効の場合は生徒情報枠は表示対象外
              // if(!state.sheet.is_sort_answer_image_enable && sheet_field.kind == Common.SheetFieldKindEnum.STUDENT_INFO){
              //   continue;
              // }
              
              const sheetField: SheetField = new SheetField(sheet_field);
              pageItem.sheetFields.push(sheetField);

              if(sheetField.rim != null){
                let fieldItem = new FieldItem();
                fieldItem.key = state.key++;
                fieldItem.x = sheetField.rim[0];
                fieldItem.y = sheetField.rim[1];
                fieldItem.width = sheetField.rim[2];
                fieldItem.height = sheetField.rim[3];
                fieldItem.sheetField = sheetField;
                pageItem.fieldItems.push(fieldItem);
              }
            }
            state.pageItems.push(pageItem);
          }
        }

        focus();
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch("goSheetList");
      });

      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
      window.removeEventListener("resize", adjustHeight);
    });

    return {
      ...toRefs(state),
      currentPageItem,
      parentW,
      sizeStyle,
      baseFieldStyle,
      sheetFieldNamePosStyle,
      isSelected,
      focus,
      adjustHeight,
      adjustWidth,
      scaleUp,
      scaleDown,
      toggleDeleteMode,
      mouseDown,
      mouseMove,
      mouseUp,
      mouseLeave,
      addFieldItem,
      dragStop,
      resizeStop,
      fieldClick,
      trClick,
      deleteFieldItem,
      changeCurrentFieldItem,
      clearCurrentItem,
      autoCreateFieldItems,
      resetFieldItems,
      fixFieldItems,
      autoAssignSheetFields,
      setSortNo,
      manualAssignSheetFields,
      resetSheetFields,
      saveSheetFields,
      changePage,
      pressedBackspace,
      copyFieldItem,
      pressedC,
      pressedShift,
      unpressedShift,
      pressedArrowDown,
      pressedArrowUp,
    };
  }
});
